import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "パスワードをリセットします", -1)
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, "パスワードをリセットしました。", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "引き続き和楽美Onlineをご利用ください", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.$style.parent
  }, [
    (!_ctx.state.submitted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_el_form_item, { label: "新しいパスワード  " }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "password",
                modelValue: _ctx.state.pass,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.pass) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "パスワードを再度入力" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "password",
                modelValue: _ctx.state.confirmPass,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.confirmPass) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            color: _ctx.BUTTON_COLOR,
            round: true,
            onClick: _ctx.submit
          }, {
            default: _withCtx(() => [
              _createTextVNode("変更")
            ]),
            _: 1
          }, 8, ["color", "onClick"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.state.submitted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createVNode(_component_el_button, {
            color: _ctx.BUTTON_COLOR,
            round: true,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push('/')))
          }, {
            default: _withCtx(() => [
              _createTextVNode("再度ログインする")
            ]),
            _: 1
          }, 8, ["color"])
        ]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}